import React, { createContext, useContext, ReactNode } from 'react'

interface TabContextValue {
  currentTab: string // 'DEFAULT' or UF code like 'SP', 'RJ'
}

const TabContext = createContext<TabContextValue | undefined>(undefined)

export const TabProvider: React.FC<{ tab: string; children: ReactNode }> = ({ tab, children }) => {
  return <TabContext.Provider value={{ currentTab: tab }}>{children}</TabContext.Provider>
}

export const useTabContext = () => {
  const context = useContext(TabContext)
  if (!context) {
    throw new Error('useTabContext must be used within TabProvider')
  }
  return context
}

/**
 * Builds the field path based on current tab
 * @param baseField - e.g., 'heroImage' or 'sections.hero.title'
 * @returns Full field path like 'default.heroImage' or 'uf.SP.sections.hero.title'
 */
export const useFieldPath = (baseField: string): string => {
  const { currentTab } = useTabContext()

  if (currentTab === 'DEFAULT') {
    return `default.${baseField}`
  }

  return `uf.${currentTab}.${baseField}`
}
